import React from 'react';

import Tooltip from 'components/tooltip';

interface Props {
  children?: React.ReactNode;
  header: string;
  path: string;
  subheader?: string;
  target?: '_blank';
}

export default function Association({ children, header, path, subheader, target }: Props) {
  return (
    <a className="crm-page__associations__link" href={path} target={target}>
      <div className="crm-page__associations__panel mb-1">
        <div className="d-flex flex-column">
          <Tooltip content={header} dark onlyOnOverflow>
            <h4 className="m-0"><b>{header}</b></h4>
          </Tooltip>

          {subheader &&
            <span className="text-muted text-truncate">{subheader}</span>
          }
        </div>

        {children &&
          <div className="d-flex flex-row text-muted">
            {children}
          </div>
        }
      </div>
    </a>
  );
}
